/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ViewersWatchingContainer_story = {
    readonly id: string;
    readonly viewerCount: number | null;
    readonly isClosed: boolean;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly " $refType": "ViewersWatchingContainer_story";
};
export type ViewersWatchingContainer_story$data = ViewersWatchingContainer_story;
export type ViewersWatchingContainer_story$key = {
    readonly " $data"?: ViewersWatchingContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ViewersWatchingContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewersWatchingContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerCount",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "LiveConfiguration",
                    "kind": "LinkedField",
                    "name": "live",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enabled",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '8cf7b456333ea17984057975718fa70c';
export default node;
